import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { useToast } from 'vue-toastification'

const toast = useToast()

// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options = {
  position: "top-right",
  timeout: 3000,
  closeOnClick: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: false,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
};

export default {
  install: (app) => {
    app.use(Toast, options);
    app.config.globalProperties.$toast = toast;
  }
}
